'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RECEIVE_COMPANY_INFO = exports.RECEIVE_COMPANY_INFO = 'RECEIVE_COMPANY_INFO';
var FETCH_COMPANY_INFO = exports.FETCH_COMPANY_INFO = 'FETCH_COMPANY_INFO';
var COMPANY_INFO_REQUEST = exports.COMPANY_INFO_REQUEST = 'COMPANY_INFO_REQUEST';
var COMPANY_INFO_REQUEST_ERROR = exports.COMPANY_INFO_REQUEST_ERROR = 'COMPANY_INFO_REQUEST_ERROR';
var TOGGLE_FOLLOW_COMPANY_REQUEST = exports.TOGGLE_FOLLOW_COMPANY_REQUEST = 'TOGGLE_FOLLOW_COMPANY_REQUEST';
var TOGGLE_FOLLOW_COMPANY_ERROR = exports.TOGGLE_FOLLOW_COMPANY_ERROR = 'TOGGLE_FOLLOW_COMPANY_ERROR';
var TOGGLE_FOLLOW_COMPANY = exports.TOGGLE_FOLLOW_COMPANY = 'TOGGLE_FOLLOW_COMPANY';
var BLOCK_COMPANY_REQUEST = exports.BLOCK_COMPANY_REQUEST = 'BLOCK_COMPANY_REQUEST';
var BLOCK_COMPANY_SUCCESS = exports.BLOCK_COMPANY_SUCCESS = 'BLOCK_COMPANY_SUCCESSS';
var BLOCK_COMPANY_ERROR = exports.BLOCK_COMPANY_ERROR = 'BLOCK_COMPANY_ERROR';
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RECEIVE_COMPANY_INFO, 'RECEIVE_COMPANY_INFO', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_COMPANY_INFO, 'FETCH_COMPANY_INFO', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(COMPANY_INFO_REQUEST, 'COMPANY_INFO_REQUEST', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(COMPANY_INFO_REQUEST_ERROR, 'COMPANY_INFO_REQUEST_ERROR', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(TOGGLE_FOLLOW_COMPANY_REQUEST, 'TOGGLE_FOLLOW_COMPANY_REQUEST', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(TOGGLE_FOLLOW_COMPANY_ERROR, 'TOGGLE_FOLLOW_COMPANY_ERROR', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(TOGGLE_FOLLOW_COMPANY, 'TOGGLE_FOLLOW_COMPANY', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(BLOCK_COMPANY_REQUEST, 'BLOCK_COMPANY_REQUEST', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(BLOCK_COMPANY_SUCCESS, 'BLOCK_COMPANY_SUCCESS', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(BLOCK_COMPANY_ERROR, 'BLOCK_COMPANY_ERROR', 'src/constants/actionTypes.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/constants/actionTypes.js
// module id = ocry
// module chunks = 62 63